"use client";
import { useState } from "react";
import CountrySelector from "@/components/CountrySelector/CountrySelector";
import TreatmentCost from "@/components/TreatmentCost/TreatmentCost";
import CostInIndia from "@/components/CostInIndia/CostInIndia";
import RelatedSearch from "../RelatedSearch/RelatedSearch";
import Testimonial from "../Testimonial/Testimonial";
import VideoCard from "../VideoCard/VideoCard";
import CitiesCost from "../CitiesCost/CitiesCost";
import Factors from "../Factors/Factors";
import Inclusions from "../Inclusions/Inclusions";
import DoctorsCarousel from "../DoctorsCarousel/DoctorsCarousel";
import Diagnosis from "../Diagnosis/Diagnosis";
import AboutPackage from "../About/About";
import CustomCarousel from "../CustomCarousel/CustomCarousel.js";

export default function TreatmentCountryContent({ data, country }) {
  const imageUrl = data?.data[0]?.treatment_list_detail?.img?.url;
  const [selectedCountry, setSelectedCountry] = useState(country || "India");

  const countrySpecificData =
    data?.data[0]?.treatment_list_detail?.countryWiseTreatmentDetails?.find(
      (detail) =>
        detail?.country_name?.toLowerCase() === selectedCountry?.toLowerCase(),
    ) || null;

  return (
    <>
      <CountrySelector
        onCountryChange={setSelectedCountry}
        initialCountry={selectedCountry}
      />

      <AboutPackage
        img={imageUrl}
        info={data?.data[0]?.treatment_list_detail?.description}
        name={data?.data[0]?.name}
      />
      {data?.data[0]?.treatment_list_detail?.diagnosis?.length > 0 && (
        <Diagnosis
          diagnosisInfo={data?.data[0]?.treatment_list_detail?.diagnosis}
          name={data?.data[0]?.treatment_list_detail?.DiagnosisDescriptions}
        />
      )}
      {data?.data[0]?.top_doctors && (
        <DoctorsCarousel
          itemsPerPage={3}
          data={{ data: data?.data[0]?.top_doctors }}
        />
      )}
      {countrySpecificData?.treatmentCost?.length > 0 && (
        <TreatmentCost
          info={countrySpecificData.treatmentCost}
          name={data?.data[0]?.name}
          country={selectedCountry}
        />
      )}
      {data?.data[0]?.treatment_list_detail?.inclusions?.length > 0 && (
        <Inclusions
          name={data?.data[0]?.name}
          inclusion={data?.data[0]?.treatment_list_detail?.inclusions}
          note=""
        />
      )}
      {data?.data[0]?.treatment_list_detail?.factors?.length > 0 && (
        <Factors
          name={data?.data[0]?.name}
          factors={data?.data[0]?.treatment_list_detail?.factors}
          description={data?.data[0]?.treatment_list_detail?.factorsDescription}
        />
      )}
      {countrySpecificData?.costInfoAcrossIndia?.length > 0 && (
        <CostInIndia
          name={data?.data[0]?.name}
          costInfo={countrySpecificData.costInfoAcrossIndia}
          country={selectedCountry}
        />
      )}
      {data?.data[0]?.treatment_list_detail?.cityWiseCost?.length > 0 && (
        <CitiesCost
          name={data?.data[0]?.name}
          costInfo={data?.data[0]?.treatment_list_detail?.cityWiseCost}
        />
      )}

      {data?.data[0]?.relatedVideos?.length > 0 && (
        <div className="my-12 px-[50px] py-8 bg-gray-50 rounded-lg">
          <h2 className="text-2xl font-bold text-gray-800 text-center mb-8 relative after:content-[''] after:absolute after:-bottom-2 after:left-1/2 after:-translate-x-1/2 after:w-16 after:h-1 after:bg-blue-500 after:rounded-full">
            Related Videos
          </h2>
          <div className="w-full mb-10">
            {/* Replace the grid with CustomCarousel */}
            <CustomCarousel itemsPerPage={3}>
              {data.data[0].relatedVideos?.map((video) => (
                <VideoCard key={video.id} video={video} />
              ))}
            </CustomCarousel>
          </div>
        </div>
      )}
      {data?.data[0]?.treatment_list_detail?.faqData && (
        <Testimonial
          data={data?.data[0]?.treatment_list_detail?.testimonials}
        />
      )}
      {data?.data[0]?.treatment_list_detail?.searches && (
        <RelatedSearch
          name={data?.data[0]?.name}
          data={data?.data[0]?.treatment_list_detail?.searches?.map((i) => ({
            name: i.name,
            url: i.url,
          }))}
        />
      )}
    </>
  );
}
